module.exports = __webpack_public_path__ + "static/img/photo.f5d3217.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photo.png
// module id = gDh6
// module chunks = 106